export { InternalContactsView } from "./_components/InternalContactsView";
export { InternalContactsList } from "./_components/InternalContactsList";
export { InternalContactsItem } from "./_components/InternalContactsItem";
export { InternalContactsCallView } from "./_components/InternalContactsCallView";
export { InternalWebRTCProvider, useInternalWebRTC, useOptionalInternalWebRTC } from "./_context/InternalWebRTCContext";
export { InternalContactsSectionHeader } from "./_components/InternalContactsSectionHeader";

export type {
  Contact,
  GetContactsResponse,
  ContactRole,
  MessageDirection,
  MarkContactAsReadParams,
  MarkContactAsReadResponse,
} from "./_types/internalContacts.types";

export type {
  ContactPersonStatus,
  WorkforcePresenceItem,
  WorkforcePresenceStatus,
  TransferAgentStatus,
} from "./_types/workforcePresence.types";

export {
  fetchInternalContacts,
  markInternalContactAsRead,
} from "./_queries/internalContacts.queries";

export {
  useInternalContacts,
  INTERNAL_CONTACTS_QUERY_KEY,
  getInternalContactsQueryKey,
} from "./_hooks/useInternalContacts";

export {
  useWorkforcePresence,
  WORKFORCE_PRESENCE_QUERY_KEY,
  getContactPresenceStatus,
} from "./_hooks/useWorkforcePresence";

export {
  useAgentStatusQuery,
  AGENT_STATUS_QUERY_KEY,
  getAgentStatusForContact,
  findAgentStatusForContact,
} from "./_hooks/useAgentStatusQuery";

export { useContactPersonStatus } from "./_hooks/useContactPersonStatus";

export { ContactPresenceDot } from "./_components/ContactPresenceDot";

export {
  getContactId,
  getContactTitle,
  getContactSubtitle,
  ORGANIZATION_CONTACT_ROLES,
} from "./_utils/internalContacts.utils";

export {
  isCallableContact,
  buildCallRoomName,
} from "./_utils/callRoom.utils";
